export function initVideoFull(scope = document) {

  const sections = scope.querySelectorAll('[data-video-full]');

  if (!sections.length) return;

  sections.forEach((section) => {

    // Autoplay when in view
    if (section.hasAttribute('data-video-autoplay')) {
      const video = section.querySelector('video');
      if (video) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play().catch(err => console.log('Autoplay blocked:', err));
            } else {
              video.pause();
            }
          });
        }, {
          threshold: 0.1
        });
        observer.observe(section);
      }
      return;
    }

    // Handle video lightbox modals
    const poster = section.querySelector('[data-video-poster]');
    const targetSelector = poster ? poster.getAttribute('data-bs-target') : null;
    const modalEl = targetSelector ? document.querySelector(targetSelector) : section.querySelector('.modal');

    if (modalEl) {
      const video = modalEl.querySelector('video');

      modalEl.addEventListener('shown.bs.modal', () => {
        if (video) {
          video.play();
        }
      });

      modalEl.addEventListener('hide.bs.modal', () => {
        if (video) {
          video.pause();
        }
      });
      return;
    }

    const playBtn = section.querySelector('[data-video-play]');
    const videoWrap = section.querySelector('[data-video-container]');

    if (!playBtn || !videoWrap) return;

    playBtn.addEventListener('click', () => {

      const type = section.dataset.videoType;

      if (type === 'youtube') {

        const videoId = section.dataset.videoId;

        videoWrap.innerHTML = `
          <iframe
            src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen>
          </iframe>
        `;

      }

      if (type === 'shopify') {

        const video = videoWrap.querySelector('video');

        if (video) {
          video.play();
        }

      }

      section.classList.add('is-playing');

    });

  });

}